import axios from 'axios';
import { OrganizationsCompaniesprofile, OrganizationHiretechcopmany, OrganizationsupdateCompanyProject, 
  OrganizationsallprojectsCompanyProject, Organizationsprojectsdata, OrganizationsDownloadreume } from "./base_url";

export const fetchOrganizationProfile = async () => {
  const token = localStorage.getItem('company_token');
  const response = await axios.get(`${OrganizationsCompaniesprofile}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

export const updateOrganizationProfile = async (formData) => {
  const token = localStorage.getItem('company_token');
  const response = await axios.put(`${OrganizationsCompaniesprofile}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getCompanyProjects = async () => {
  const token = localStorage.getItem('company_token');

  const response = await axios.get(`${Organizationsprojectsdata}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data.data; 
};

export const fetchCompanyHiringPosts = async () => {
  try {
    const token = localStorage.getItem('company_token');
    const response = await axios.get(`${OrganizationHiretechcopmany}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching company data:', error);
    throw error;
  }
};

export const updateCompanyProject = async (projectId, updatedData) => {
  const token = localStorage.getItem('company_token'); 
  const response = await axios.put(
    `${OrganizationsupdateCompanyProject}/${projectId}`,
    updatedData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const deleteProjectById = async (projectId) => {
  try {
    const token = localStorage.getItem('company_token');

    const response = await axios.delete(
      `${OrganizationsallprojectsCompanyProject}/${projectId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to delete project:', error);
    throw error;
  }
};

export const downloadResumeFile = async (email, path) => {
  try {
    const token = localStorage.getItem('company_token');
    const response = await axios.get(`${OrganizationsDownloadreume}`, {
      params: { email, path },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });

    const fileName = path.split('/').pop();
    const url = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Download error:', error);
    alert('Failed to download resume.');
  }
};

